import { Radio } from 'antd';

/**
 * @component SortFilters.tsx
 * @description SortFilters component
 * @return { Component }
 */
interface SortFiltersProps {
  sortsOnChange: (value: 'createdAt' | 'fechaRealizacion' | 'closedAt') => void;
  isDateSort: boolean;
  value?: string;
}

function SortFilters(props: SortFiltersProps) {

  return (
    <Radio.Group
      onChange={(event) => {
        props.sortsOnChange(event.target.value);
      }}
      value={props.value}
    >
      {!props.isDateSort ? (
        <>
          <Radio value={'%2BcreatedAt'}>Más recientes</Radio>
          <Radio value={'-createdAt'}>Menos recientes</Radio>
          <Radio value={'-titulo'}>A {'->'} Z</Radio>
          <Radio value={'%2Btitulo'}>Z {'->'} A</Radio>
        </>
      ) : (
        <>
          <Radio value={'createdAt'}>Fecha de creación</Radio>
          <Radio value={'fechaRealizacion'}>Fecha de realización</Radio>
          <Radio value={'closedAt'}>Fecha de cierre</Radio>
        </>
      )}
    </Radio.Group>
  );
}
export default SortFilters;
